"use strict";
/**
 * The main module.
 * Contains the {@link Parjs} object and the most commonly used public interfaces.
 * @module parjs
 * @preferred
 */ /** iooi*/
Object.defineProperty(exports, "__esModule", { value: true });
const static_1 = require("./internal/static");
var errors_1 = require("./errors");
exports.ParjsParsingFailure = errors_1.ParjsParsingFailure;
var reply_1 = require("./reply");
exports.ReplyKind = reply_1.ReplyKind;
/**
 * The central API of the parjs library. Contains building block parsers and static combinators.
 */
exports.Parjs = new static_1.ParjsParsers();
/**
 *
 */
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/parjs/index.js
// module id = 147
// module chunks = 0 1